import React from 'react';
import { StyleSheet, View } from 'react-native';
import theme from 'shared/styles/theme';

import ExternalTypeSelectionScreen from './ExternalTypeSelectionScreen';

const ExternalAccountsAndCards = () => {
  return (
    <View style={styles.screen}>
      <ExternalTypeSelectionScreen />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default ExternalAccountsAndCards;
